module.exports = __webpack_public_path__ + "static/media/icon-symptoms-fever.4b74ccb9.svg";